import { get, post, put, destroy } from "./axiosClient";

const managementService = {
  //USER MANAGEMENT
  getUserList: (groupId, searchKeyword, limit, offset) =>
    get(
      `/user/list?groupId=` +
        groupId +
        `&searchKeyword=` +
        searchKeyword +
        `&limit=` +
        limit +
        `&offset=` +
        offset
    ),
  getLastUserList: (limit, offset) =>
    get(`/user/lastRegisterUsers?limit=` + limit + `&offset=` + offset),
  getUserListWithExcludedUserIds: (
    groupId,
    searchKeyword,
    limit,
    offset,
    body
  ) =>
    post(
      `/user/list?groupId=` +
        encodeURIComponent(groupId || "") +
        `&searchKeyword=` +
        encodeURIComponent(searchKeyword || "") +
        `&limit=` +
        encodeURIComponent(limit) +
        `&offset=` +
        encodeURIComponent(offset),
      body
    ),
  getUser: (userId) => get(`/user/get/` + userId),
  searchUser: (filter) => post(`/user/search`, filter),
  createUser: (user) => post(`/user`, user),
  editUser: (user) => put(`/user`, user),
  bulkSetMenuPermissions: (body) => post(`/user/menu-permissions/bulk`, body),
  deleteAllUsers: (ids) => post(`/user/deleteAll`, ids),
  setProfile: (user) => post(`/user/profile`, user),
  sendVerificationEmail: (email, language) =>
    post(`/user/verify?lang=` + language, email),
  register: (registerBody) => post(`/user/register`, registerBody),
  sendPasswordEmail: (email, language) =>
    post(`/user/password?lang=` + language, email),

  //USER GROUP MANAGEMENT
  getUserGroupList: (searchKeyword, limit, offset) =>
    get(
      `/group/list?searchKeyword=` +
        searchKeyword +
        `&limit=` +
        limit +
        `&offset=` +
        offset
    ),
  getUserGroupListById: (groupId) => get(`/group/` + groupId),
  createUserGroup: (userGroup) => post(`/group`, userGroup),
  editUserGroup: (userGroup) => put(`/group`, userGroup),
  deleteAllUserGroups: (ids) => post(`/group/deleteAll`, ids),

  //MEETING MANAGEMENT
  getMeeting: (id) => get(`/meeting/` + id),
  getMeetingList: (filter) => post(`/meeting/list`, filter),
  createMeeting: (meeting) => post(`/meeting`, meeting),
  editMeeting: (meeting) => put(`/meeting`, meeting),
  deleteAllMeetings: (ids) => post(`/meeting/deleteAll`, ids),

  //LDAP MANAGEMENT
  getLdapList: () => get(`/ldap/list`),
  createLdap: (ldapSettings) => post(`/ldap`, ldapSettings),
  editLdap: (ldapSettings) => put(`/ldap`, ldapSettings),
  deleteAllLdap: (ids) => post(`/ldap/deleteAll`, ids),
  checkLdap: (ldapSettings) => post(`/ldap/check`, ldapSettings),
  syncLdap: (params) => post(`/ldap/sync`, params, { timeout: 60000 * 30 }),
  syncAllLdap: () => post(`/ldap/sync-all`, {}, { timeout: 60000 * 30 }),
  deleteImportedUsers: (params) => post(`/ldap/deleteImportedUsers`, params),

  // APP BRAND (ROOT_ADMIN)
  getBrandSettings: () => get(`/brand`),
  getMailSettings: () => get(`/brand/mail`),
  updateBrandSettings: (body) => put(`/brand`, body),
  testMailSettings: (body) => post(`/brand/mail/test`, body),
  purgeChatHistoryNow: () => post(`/brand/chat-history/purge`, {}),

  // APP STATS
  getAppStats: (range = "today", { force = false } = {}) =>
    get(
      `/stats?range=` +
        encodeURIComponent(range) +
        (force ? `&force=1` : "")
    ),
  refreshAppStats: (range = "today") =>
    post(`/stats/refresh`, { range }),
  purgeOrphanQueues: () => post(`/stats/rabbit/purge-orphans`, {}),

  // AUDIT LOG
  getAuditLogs: (params = {}) => {
    const q = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
        q.set(key, params[key]);
      }
    });
    const qs = q.toString();
    return get(`/audit${qs ? `?${qs}` : ""}`);
  },
  getAuditActions: () => get(`/audit/actions`),
  getAuditStats: () => get(`/audit/stats`),
  purgeAuditLogs: (months) => post(`/audit/purge`, { months }),
  logout: () => post(`/auth/logout`, {}),
};

export default managementService;
